import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function Skills({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t('dashboardComponents.Console.RefDataManagement.Skills.skillName'),
      field: 'name',
      sortable: true,
    },
    { name: t('common.sortOrder'), field: 'sortOrder', sortable: true },
    {
      name: t('dashboardComponents.Console.RefDataManagement.Skills.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];

  return (
    <TableView
      setItemCount={setItemCount}
      dataName="Skill"
      getDataHandler={AdminService.getSkills}
      deleteDataHandler={AdminService.deleteSkill}
      createDataHandler={AdminService.createSkill}
      updateDataHandler={AdminService.updateSkill}
      viewLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.RefDataManagement.Skills.skillName'
          ),
          field: 'name',
        },
      ]}
      viewRightColumnFields={[
        { label: t('common.sortOrder'), field: 'sortOrder' },
        {
          label: t(
            'dashboardComponents.Console.RefDataManagement.Skills.notes'
          ),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.RefDataManagement.Skills.skillName'
          ),
          field: 'name',
          validation: ['string', 'required'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.Skills.skillNamePlaceholder'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.Skills.sortOrderPlaceholder'
          ),
          maxLength: 5,
        },
        {
          label: t(
            'dashboardComponents.Console.RefDataManagement.Skills.notes'
          ),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.Skills.notesPlaceholder'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
